class ScrollbarNavigation extends HTMLElement {
	connectedCallback() {
		this.carousel = document.getElementById(this.getAttribute("aria-controls"));
		this.thumb = this.querySelector("[data-scrollbar-thumb]");
		if (!this.carousel || !this.thumb) return;

		this.update();

		// Update on all relevant events
		["scroll", "carousel:filter", "carousel:change", "carousel:select"].forEach(event =>
			this.carousel.addEventListener(event, () => this.update())
		);

		window.addEventListener("resize", () => this.update());

	}

	get totalItems() {
		return this.carousel.querySelectorAll('[role="group"]:not([hidden])').length || 1;
	}

	update() {
		if (this.totalItems <= 1) {
			this.thumb.style.transform = `translateX(0%)`;
			this.thumb.style.width = `100%`;
			return;
		}

		const { scrollLeft, scrollWidth, clientWidth } = this.carousel;
		const containerWidth = this.thumb.parentElement.offsetWidth;
		const thumbWidth = containerWidth / this.totalItems;

		const maxThumbX = containerWidth - thumbWidth;
		const maxScrollX = scrollWidth - clientWidth;
		const scrollRatio = scrollLeft / maxScrollX;

		this.thumb.style.width = `${thumbWidth}px`;
		this.thumb.style.transform = `translateX(${scrollRatio * maxThumbX}px)`;
	}

}

if (!customElements.get("scrollbar-navigation")) {
	customElements.define("scrollbar-navigation", ScrollbarNavigation);
}
